import { ExternalLink as OpenInNew } from 'lucide-react';
import React from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';

const AssessmentHeader = () => {
    const company = useSelector((state) => state.companyReducer.company);
    const logo = company.logoLocation || "https://readymadeui.com/readymadeui.svg";
    const navigate = useNavigate();

    const handleLoginClick = () => navigate("/sign-in");
    const handleAssessmentsClick = () => navigate("/assessments");
    const handleHomeClick = () => navigate("/");
    const handleFeatureClick = () => navigate("/features");
    const handleAboutClick = () => navigate("/about");
    const handleContactClick = () => navigate("/contact");

    return (
        <>
            <header className="flex shadow-md py-4 px-4 sm:px-10 bg-[rgb(8,64,88)] font-[sans-serif] min-h-[70px] tracking-wide relative z-50">
                <div className="flex flex-wrap items-center justify-between gap-5 w-full">
                    <button onClick={handleHomeClick} className="max-sm:hidden">
                        <img src={logo} alt="logo" className="w-36" />
                    </button>
                    <button onClick={handleHomeClick} className="hidden max-sm:block">
                        <img src={logo} alt="logo" className="w-9" />
                    </button>

                    <div id="collapseMenu" className="max-lg:hidden lg:block">
                        <ul className="lg:flex gap-x-5">
                            <li className="max-lg:border-b border-gray-300 max-lg:py-3 px-3">
                                <button onClick={handleHomeClick} className="hover:text-white text-white block font-semibold text-[15px]">
                                    Home
                                </button>
                            </li>

                            <li className="max-lg:border-b border-gray-300 max-lg:py-3 px-3">
                                <button onClick={handleFeatureClick} className="hover:text-white text-gray-200 block font-semibold text-[15px]">
                                    Feature
                                </button>
                            </li>

                            <li className="max-lg:border-b border-gray-300 max-lg:py-3 px-3">
                                <button onClick={handleAboutClick} className="hover:text-white text-gray-200 block font-semibold text-[15px]">
                                    About
                                </button>
                            </li>
                            <li className="max-lg:border-b border-gray-300 max-lg:py-3 px-3">
                                <button onClick={handleContactClick} className="hover:text-white text-gray-200 block font-semibold text-[15px]">
                                    Contact
                                </button>
                            </li>
                        </ul>
                    </div>

                    <div className="flex max-lg:ml-auto space-x-4">
                        {/* Login Button */}
                        <button
                            onClick={handleLoginClick}
                            className="px-6 py-2 text-sm rounded-full font-bold text-white border-2 bg-transparent hover:bg-white hover:text-[rgb(8,64,88)] transition-all ease-in-out duration-300 transform hover:scale-110 hover:shadow-lg active:scale-95 active:bg-[rgb(8,64,88)] active:text-white"
                        >
                            Login
                        </button>

                        {/* Try Now Button */}
                        <button
                            onClick={handleAssessmentsClick}
                            className="px-6 py-2 text-sm rounded-full font-bold text-white border-2 border-[rgb(8,64,88)] bg-[rgb(8,64,88)] transition-all ease-in-out duration-300 transform hover:scale-110 hover:bg-transparent hover:text-[rgb(8,64,88)] active:scale-95 active:bg-[rgb(8,64,88)] active:text-white active:shadow-none"
                        >
                            Try Now <OpenInNew />
                        </button>
                    </div>
                </div>
            </header>
        </>
    );
};

export default AssessmentHeader;
